export default __webpack_public_path__ + "static/media/gardens.e2f3f5cd.png";